import axios from '@/libs/http'

/**
 * 获取订单列表
 * */
export const getOrderList = (keyword, pageNo, pageSize , types, status) => {
    let data = new URLSearchParams()
    if(keyword != null && keyword != ''){
        data.append("keyword", keyword)
    }
    data.append("pageNo", pageNo)
    data.append("pageSize", pageSize)
    data.append("types", types)
    data.append("status", status)
    return axios.request({
        url: '/s/kf/order/list',
        data,
        method: 'post'
    })
}
/**
 * 获取订单详情
 */
export const getOrder = (id) => {
    return axios.request({
        url: '/s/kf/order/get',
        params: {
            id
        },
        method: 'get'
    })
}

/**
 *  获取店员列表(更换店员)
 *  */
export const getClerkList = (clerkName) => {
    return axios.request({
        url: '/s/kf/order/getClerkList',
        params: {
            clerkName
        },
        method: 'get'
    })
}

/**
 *  获取订单类型...
 *  */
export const getItemList = (clerkId) => {
    return axios.request({
        url: '/s/kf/order/getItemList',
        params: {
            clerkId
        },
        method: 'get'
    })
}

/**
 * 更换店员
 * */
export const replaceOrderClerk = (id, clerkId,remark) => {
    var data = new URLSearchParams();
    data.append("id", id);
    data.append("clerkId", clerkId);
    if (remark != null) {
        data.append("remark", remark)
    }
    return axios.request({
        url: '/s/kf/order/replaceOrderClerk',
        data,
        method: 'post'
    })
}

/**
 * 提交创建订单
 * */
export const submitOrder = (type, clerkId, itemId, isContinued, totalAmount, userWechatId, userMemo) => {
    return axios.request({
        url: '/s/kf/order/inputOrder',
        params: {
            type,
            clerkId,
            itemId,
            isContinued,
            totalAmount,
            userWechatId,
            userMemo
        },
        method: 'post'
    })
}

/**
 * 重新抢单
 */
export const revokeGrabOrder = (id, options, remark) => {
    var data = new URLSearchParams();
    data.append("id", id);
    data.append("options", options);
    data.append("remark", remark);
    return axios.request({
        url: '/s/kf/order/revokeGrabOrder',
        data,
        method: 'post'
    })
}

/**
 * 标记顶单
 */
export const signOrder = (id) => {
    var data = new URLSearchParams();
    data.append("id", id)
    return axios.request({
        url: '/s/kf/order/signOrder',
        data,
        method: 'post'
    })
}

/**
 * 标记顶单
 */
export const updateFirst = (id) => {
    var data = new URLSearchParams();
    data.append("id", id)
    return axios.request({
        url: '/s/kf/order/updateFirst',
        data,
        method: 'post'
    })
}

/**
 * 获取订单详情
 */
export const updateShopMemo = (id,shopMemo) => {
    return axios.request({
        url: '/s/kf/order/updateShopMemo',
        params: {
            id,
            shopMemo
        },
        method: 'get'
    })
}

/**
 * 获取退款订单
 * */
export const getRefundOrder = (orderId) => {
    return axios.request({
        url: '/s/kf/order/getRefundOrder',
        params: {
            orderId
        },
        method: 'get'
    })
}

/**
 * 发起退款
 */
export const refund = (orderId, refundFee, refundDesc,refundPath) => {
    return axios.request({
        url: '/s/kf/order/refundV2',
        params: {
            orderId,
            refundFee,
            refundDesc,
            refundPath
        },
        method: 'post'
    })
}


/**
 * 获取订单续单申请列表
 */
export const continuedApplyList = (status, keyword, pageNo, pageSize) => {
    let data = new URLSearchParams()
    if (status != null) {
        data.append("status", status)
    }
    if (keyword != null) {
        data.append("keyword", keyword)
    }
    data.append("pageNo", pageNo)
    data.append("pageSize", pageSize)
    return axios.request({
        url: '/s/kf/order/continuedApplyList',
        data,
        method: 'post'
    })
}

/**
 * 审核
 */
export const verifyOrderContinuedApply = (id, status,reason) => {
    return axios.request({
        url: '/s/kf/order/verify',
        params: {
            id,
            status,
            reason
        },
        method: 'post'
    })
}

